import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TIMEFRAMES } from './api';

/**
 * Hydrate Tick Studio controls from URL once dates are available, then keep
 * date/symbol/tf/rth in sync for shareable deep links.
 */
export function useTickStudioUrl({
    dates,
    date,
    setDate,
    symbol,
    setSymbol,
    setSymbolInput,
    tf,
    setTf,
    rth,
    setRth,
}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const hydrated = useRef(false);

    const effectiveDate = date || dates[0] || '';

    useEffect(() => {
        if (hydrated.current || !dates.length) return;

        const urlDate = searchParams.get('date');
        const urlSymbol = searchParams.get('symbol');
        const urlTf = searchParams.get('tf');
        const urlRth = searchParams.get('rth');

        if (urlDate && dates.includes(urlDate)) {
            setDate(urlDate);
        }
        if (urlSymbol) {
            setSymbol(urlSymbol);
            setSymbolInput(urlSymbol);
        }
        if (urlTf && TIMEFRAMES.includes(urlTf)) {
            setTf(urlTf);
        }
        if (urlRth === '0') {
            setRth(false);
        } else if (urlRth === '1') {
            setRth(true);
        }

        hydrated.current = true;
    }, [dates, searchParams, setDate, setSymbol, setSymbolInput, setTf, setRth]);

    useEffect(() => {
        if (!hydrated.current || !effectiveDate) return;

        const next = new URLSearchParams(searchParams);
        next.set('view', 'ticklake');
        next.set('date', effectiveDate);
        if (symbol) {
            next.set('symbol', symbol);
        } else {
            next.delete('symbol');
        }
        next.set('tf', tf);
        next.set('rth', rth ? '1' : '0');

        const changed =
            searchParams.get('view') !== 'ticklake' ||
            searchParams.get('date') !== effectiveDate ||
            searchParams.get('symbol') !== (symbol || null) ||
            searchParams.get('tf') !== tf ||
            searchParams.get('rth') !== (rth ? '1' : '0');

        if (changed) {
            setSearchParams(next, { replace: true });
        }
    }, [effectiveDate, symbol, tf, rth, searchParams, setSearchParams]);

    return { effectiveDate };
}
